<script setup lang="ts">
defineProps<{
  title: string
  description?: string
  marginBottom?: string
  isHtml?: boolean
}>()
defineSlots<{
  action?: () => any
}>()
</script>

<template>
  <div :class="['flex flex-col', marginBottom || 'mb-6']">
    <div class="flex items-center justify-between">
      <h2 class="text-2xl font-bold text-gray-900">
        {{ title }}
      </h2>
      <slot name="action" />
    </div>
    <p
      v-if="description"
      class="text-gray-600 mt-2 text-base"
      :class="{ 'description-html': isHtml }"
      v-html="isHtml ? description : description"
    />
  </div>
</template>

<style scoped>
:deep(.description-html strong) {
  font-weight: bold;
}
</style>
